<p-sidebar
  [visible]="true"
  position="bottom"
  [dismissible]="false"
  [modal]="false"
  [showCloseIcon]="false"
  styleClass="agent-bar"
>
  <div class="flex align-items-start justify-content-between flex-wrap px-5">
    <div class="flex-grow-1">
      <div class="flex align-items-start">
        <a routerLink="/"
          ><img src="assets/images/ccs-glyph-blue.svg" height="38" data-cy="ccs-logo" alt="My CCS Med Logo"
        /></a>
        <div class="ml-2">
          <h3 class="mt-0 mb-2">MyCCSMed Agent Preview</h3>
          <p class="p3 m-0 font-semibold">Signed in agent</p>
          <p class="p3 mt-0 mb-2">{{ (agent$ | async)?.email }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="agentLoadedPatient$ | async">
      <div class="mr-4">
        <p class="p3 mt-0 mb-1 font-semibold">Showing Patient {{ (agentLoadedPatient$ | async)?.patientId }}</p>
        <p class="p3 mt-0 mb-1">User ID: {{ (agentLoadedPatient$ | async)?.oktaId }}</p>
        <p *ngIf="(agentLoadedPatient$ | async)?.linkedPatients" class="p3 mt-0 mb-1">
          Linked to patient(s): {{ (agentLoadedPatient$ | async)?.linkedPatients }}
        </p>
        <p class="p3 mt-0 mb-1">
          {{ (agentLoadedPatient$ | async)?.isLegacyUser ? 'Migrated' : 'Registered' }} on:
          {{ (agentLoadedPatient$ | async)?.createdAt | formatDate: 'M/D/YYYY H:mA' }}
        </p>
        <p class="p3 mt-0 mb-2">
          Last sign in: {{ (agentLoadedPatient$ | async)?.lastSessionAt | formatDate: 'M/D/YYYY H:mA' }}
        </p>
      </div>
    </div>
  </div>
</p-sidebar>
